<template>
    <div v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="icon-lx-calendar"></i> 系统管理</el-breadcrumb-item>
                <el-breadcrumb-item>日志管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class="container" v-if="power.search">
            <div class="handle-box left">
				<el-date-picker v-model="data.date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" size="large" class="left mr10" style="width:520px" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                <el-input v-model="data.filterstr" size="large" placeholder="筛选关键词" class="handle-input ml10"></el-input>
                <el-button class="ml10" type="primary" icon="search" @click="search">搜索</el-button>
            </div>
            
            <el-table ref="roletable" :data="data.rows" border class="table" row-key="roleid">
                <el-table-column prop="optTime" label="操作时间" width="260">
                </el-table-column>
                <el-table-column prop="optUser" label="操作用户" width="120">
                </el-table-column>
                <el-table-column prop="ipAddress" label="IP地址" width="150">
                </el-table-column>
                <el-table-column prop="moduleName" label="系统模块" width="150">
                </el-table-column>
                <el-table-column prop="rightName" label="操作类型" width="210">
                </el-table-column>
                <el-table-column label="操作结果" width="120">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.logType==1">成功</el-tag> 
                        <el-tag type="danger" v-else>失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="操作描述" show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentPageChange"
                   :current-page="data.page"
                   :page-sizes="[10,20,50,100,200,300,400,500]"
                   :page-size="data.size"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="data.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'logmanage',
        data(){
            return {
                data:{
                    date:[],
                    filterstr:'',
                    total:500,
                    size:10,
                    page:1,
                    rows:[]
                },
				visible: {
					loading: false
				},
                power: {
                    pageId: 21,
                    search: false
                }
            }
        },
        methods: {
			search(change) {
				let vue = this;
				vue.loading = false;
				if (change) {
					vue.data.page = 1;
				}
				window.ax.get('api/system/syslog?starttime=' + vue.data.date[0].toDateFormatString('yyyy-MM-dd hh:mm:ss') + '&endtime=' + vue.data.date[1].toDateFormatString('yyyy-MM-dd hh:mm:ss') + '&pagesize=' + vue.data.size + '&currentpage=' + vue.data.page + '&sign=' + window.$gloable.userinfo.sign + '&filterStr=' + vue.data.filterstr).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						vue.data.rows = data.datas;
						vue.data.total = total;
						if (len == 0 && total > 0) {
							vue.data.page = Math.ceil(total / vue.data.size);
							vue.search();
						}
					} else {
						vue.$message.error(data.message);
					}
					vue.visible.loading = false;
				}).catch(err => {
					vue.$message.error('执行脚本出错，请联系管理员');
					vue.visible.loading = false;
				});
			},
            handleSizeChange(size) {
                this.data.size = size;
                this.data.page = 1;
                this.search();
            },
            handleCurrentPageChange(current) {
                this.data.page = current;
                this.search();
            }
        },
		created() {
			this.baseJS.initPower(this.power);
            var now = new Date();
            this.data.date = [
                new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0,0),
                new Date(now.getFullYear(),now.getMonth(),now.getDate(),23,59,59)
            ];
			this.search(true);
        },
		mounted() {
        }
    }
</script>

<style scoped>
    .ml10{
        margin-left: 10px;
    }
    
    .handle-input{
        width: 200px;
        display: inline-block;
    }
    .handle-box {
        margin-bottom: 20px;
    }
    
    .left {
        float: left;
    }
    
    .right {
        float: right;
    }

    .handle-select {
        width: 120px;
    }
    
    .table{
        width: 100%;
        font-size: 14px;
    }
	
	.el-range-editor.el-input__inner {
		padding: 0px 15px !important;
	}
</style>